import request from '@/utils/ajax'

export function getQqConfigList(params) {
  return request({
    url: '/wx/manage/qqBotConfig/list',
    method: 'get',
    params
  })
}

export function saveQqConfig(data) {
  return request({
    url: '/wx/manage/qqBotConfig/save',
    method: 'post',
    data
  })
}

export function editQqConfig(data) {
  return request({
    url: '/wx/manage/qqBotConfig/update',
    method: 'put',
    data
  })
}

export function deleteQqConfig(data) {
  return request({
    url: '/wx/manage/qqBotConfig/delete',
    method: 'post',
    data
  })
}

export function checkQqConnection(id) {
  return request({
    url: `/wx/manage/qqBotConfig/checkConnection/${id}`,
    method: 'put'
  })
}

export function getQqReceivers(id) {
  return request({
    url: `/wx/manage/qqBotConfig/${id}/receivers`,
    method: 'get'
  })
}

export function buildQqConfigPayload(form, editing) {
  const payload = {
    name: form.name,
    desc: form.desc,
    baseUrl: form.baseUrl,
    status: form.status
  }
  if (editing) payload.id = form.id
  if (!editing || String(form.accessToken || '').trim()) {
    payload.accessToken = form.accessToken
  }
  return payload
}

export function isValidQqBaseUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return false
  const baseUrl = value.trim()
  if (!/^https?:\/\//i.test(baseUrl) || baseUrl.includes('?') || baseUrl.includes('#')) {
    return false
  }
  try {
    let url
    if (typeof document !== 'undefined') {
      url = document.createElement('a')
      url.href = baseUrl
    } else if (typeof URL === 'function') {
      url = new URL(baseUrl)
    } else {
      return false
    }
    const authority = baseUrl.split('//')[1].split('/')[0]
    return (url.protocol === 'http:' || url.protocol === 'https:')
      && !!url.hostname
      && !!authority
      && !authority.includes('@')
  } catch (error) {
    return false
  }
}

export function hasQqTokenControlCharacter(value) {
  return String(value || '').split('').some(character => {
    const code = character.charCodeAt(0)
    return code <= 31 || (code >= 127 && code <= 159)
  })
}
